import { useAuth } from '../../contexts/auth'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAddressBook} from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState } from 'react';
import { verifyAccess } from '../../utils/admin.utils';
import AccessDenied from '../../components/access-denied/access-denied';
import './budget.scss'
import {Button} from "devextreme-react/button";
import {useHistory} from "react-router-dom";
//import ZagolovokFromMenu from "../../components/zagolovok/zagolovok";

const Budget = () => {

    const auth = useAuth()
    const dogovor = auth.selectedDog
    const history = useHistory();

    const [visiblePage, setVisiblePage] = useState(true)

    useEffect(() => {
        const pageRoles = [2,3]
        if (!verifyAccess(pageRoles, dogovor)){
            setVisiblePage(false)
            return
        }
        (async function(){
            setVisiblePage(true)
        })()
    }, [dogovor])


    return (
        <>{visiblePage ?
            <div className={'content-block dx-card responsive-paddings big-input dogovor-page'}>
                <div className="row mt20">
                    <div className="col-12">
                        <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faAddressBook} />
                        <h3><strong>Бюджетный потребитель{/*<ZagolovokFromMenu/>*/}</strong></h3>
                        <div className='col-12'><Button className="mt-4 block" type={'default'} text="Направить заявление на заключение контракта (договора) энергоснабжения на следующий период"
                                                        hint="Направить заявление на заключение контракта (договора) энергоснабжения на следующий период"
                                                        onClick={() => history.push('/budget/add-contract')}/></div>
                        <div className='col-12'><Button className="mt-4 block" type={'default'}
                                                        text="Сформировать соглашение об изменении цены контракта (договора)"
                                                        hint="Сформировать соглашение об изменении цены контракта (договора)"
                                                        onClick={() => history.push('/budget/change-contract')}/></div>
                        <div className='col-12'><Button className="mt-4 block" type={'default'}
                                                        text="Сформировать соглашение о расторжении контракта (договора)"
                                                        hint="Сформировать соглашение о расторжении контракта (договора)"
                                                        onClick={() => history.push('/budget/del-contract')}/></div>
                    </div>

                </div>
            </div>
            : <AccessDenied/>}</>
    )
}

export default Budget
